
export default "/assets/tinylytics.1a14229c.svg"